import { render, staticRenderFns } from "./AddStudent.vue?vue&type=template&id=2e1cd68d&scoped=true&"
import script from "./AddStudent.vue?vue&type=script&lang=js&"
export * from "./AddStudent.vue?vue&type=script&lang=js&"
import style1 from "./AddStudent.vue?vue&type=style&index=1&id=2e1cd68d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1cd68d",
  null
  
)

export default component.exports